import { render, staticRenderFns } from "./NavigationBarsComponent.vue?vue&type=template&id=04ca06d2&"
import script from "./NavigationBarsComponent.vue?vue&type=script&lang=js&"
export * from "./NavigationBarsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports